import { Container } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styles from 'modules/Services/Notifications/Notification/network-notification.module.scss'

const Notification = ({ networkId, type, texts, ...rest }) => {
  const { t } = useTranslation(['services'])
  const dispatch = useDispatch()

  const content = useMemo(() => {
    switch (type) {
      case 'no_accounts':
        return {
          onClick: () => {
            dispatch({
              type: 'MODAL/SHOW',
              payload: {
                modalType: 'networkText',
                modalProps: {
                  networkId,
                  textKey: 'description',
                  shouldCloseOnOverlayClick: true,
                },
              },
            })
          },
          text: t('service.notifications.no_accounts'),
        }
      case 'account_pending':
        return {
          text: t('service.notifications.account_pending', {
            logins: rest.logins.join(', '),
            count: rest.logins.length,
          }),
        }
    }
  }, [type, rest, texts, networkId])

  return (
    <Container
      className={styles['notification']}
      display={'flex'}
      flexAlign={'center'}
      flexJustify={'center'}
    >
      <span onClick={content?.onClick} className={styles['notification__text']}>
        {content.text}
      </span>
    </Container>
  )
}

Notification.propTypes = {
  networkId: PropTypes.string,
  type: PropTypes.string,
  texts: PropTypes.array,
  payload: PropTypes.object,
}

export default Notification
